import React from 'react';

import { Box, HStack, Stack } from '@chakra-ui/react';

import { FilterLabelWrapper } from 'components/DataDisplay/Box/BorderedBox/FilterLabelWrapper';
import { CustomTable2 as Table } from 'components/DataDisplay/NewTable/Table';
import { ButtonGroup, ButtonGroupItem } from 'components/DataEntry';

export const RDSAccessPolicies = () => {
  const viewByOptions = [
    { label: 'Users', value: 'User' },
    { label: 'Roles', value: 'Role' },
  ];
  const [viewBy, setViewBy] = React.useState<ButtonGroupItem>(viewByOptions[0]);
  const userColumns = [
    { header: <Box pl={10}>User</Box>, accessor: 'name' },
    { header: 'Assigned Role', accessor: 'role' },
    { header: 'Permissions', accessor: 'permissions' },
  ];
  const roleColumns = [
    { header: <Box pl={10}>Role</Box>, accessor: 'name' },
    { header: 'Assigned to User', accessor: '' },
    { header: 'Permissions', accessor: 'permissions' },
  ];

  return (
    <Stack spacing={5} h="full" w="full">
      <HStack>
        <FilterLabelWrapper>VIEW BY</FilterLabelWrapper>
        <ButtonGroup items={viewByOptions} onClick={setViewBy} value={viewBy} />
      </HStack>
      <Box flex={1} h="full" w="full">
        <Table
          columns={viewBy?.value === 'User' ? userColumns : roleColumns}
          data={[]}
        />
      </Box>
    </Stack>
  );
};
